// 9-Variant Product Configurator Engine
(function() {
  'use strict';

  var PACK_BLURBS = {
    '1 pillow': 'For one sleeper, or to try it before the household switches.',
    '2 pillows': 'For a shared bed, so nobody ends up on the old flat one.',
    '3 pillows': 'For the guest room, or one to send home to your parents.'
  };

  var PACK_QTYS = {
    '1 pillow': 1,
    '2 pillows': 2,
    '3 pillows': 3
  };

  function formatMoney(amountInRupees) {
    return '₹' + Math.round(amountInRupees).toLocaleString('en-IN');
  }

  function initConfigurator(container) {
    if (!container) return;
    var sectionId = container.getAttribute('data-section-id');
    var rawJsonEl = container.querySelector('.product-variants-json');
    if (!rawJsonEl) return;

    var variants = [];
    try {
      variants = JSON.parse(rawJsonEl.textContent);
    } catch(e) {
      console.error('[Nidra] Error parsing variants JSON', e);
      return;
    }

    var selectedSize = 'Compact';
    var selectedPackage = '1 pillow';
    var payOnline = true;

    var sizeBtns = container.querySelectorAll('.size-btn');
    var packBtns = container.querySelectorAll('.pack-btn');
    var paymentSwitchBtn = document.getElementById('PaymentSwitchBtn-' + sectionId);
    var paymentSwitchPrice = document.getElementById('PaymentSwitchPrice-' + sectionId);
    var mainPayableEl = document.getElementById('MainPayablePrice-' + sectionId);
    var mainCompareEl = document.getElementById('MainComparePrice-' + sectionId);
    var mainOffPercentEl = document.getElementById('MainOffPercent-' + sectionId);
    var mainPriceTypeBadge = document.getElementById('MainPriceTypeBadge-' + sectionId);
    var mainCodPriceNotice = document.getElementById('MainCodPriceNotice-' + sectionId);
    var configSummaryText = document.getElementById('ConfigSummaryText-' + sectionId);
    var packBlurbEl = document.getElementById('PackBlurb-' + sectionId);
    var variantIdInput = document.getElementById('SelectedVariantId-' + sectionId);
    var addToCartBtn = document.getElementById('AddToCartBtn-' + sectionId);
    var buyNowBtn = document.getElementById('BuyNowBtn-' + sectionId);

    function findVariant(size, pack) {
      var sNorm = (size || '').trim().toLowerCase();
      var pNorm = (pack || '').trim().toLowerCase();

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var o1 = (v.option1 || '').trim().toLowerCase();
        var o2 = (v.option2 || '').trim().toLowerCase();
        var o3 = (v.option3 || '').trim().toLowerCase();

        var sizeMatch = (o1 === sNorm || o2 === sNorm || o3 === sNorm);
        var packMatch = (o1 === pNorm || o2 === pNorm || o3 === pNorm);

        if (sizeMatch && packMatch) {
          return v;
        }
      }
      return variants[0] || null;
    }

    function updateUI() {
      // 1. Update Size button active states
      sizeBtns.forEach(function(btn) {
        var s = btn.getAttribute('data-size');
        var isActive = (s === selectedSize);
        btn.classList.toggle('active', isActive);
        btn.style.borderColor = isActive ? 'var(--color-brass-bright)' : 'var(--color-line-strong)';
        btn.style.background = isActive ? 'var(--color-panel-2)' : 'var(--color-panel)';
        var title = btn.querySelector('.size-title');
        if (title) title.style.color = isActive ? 'var(--color-brass-bright)' : 'var(--color-paper)';
      });

      // 2. Resolve single variant for current size + 1 pillow (for baseline separate comparison)
      var singleVariant = findVariant(selectedSize, '1 pillow');
      var singleFullPrice = singleVariant ? (singleVariant.price / 100) : 1899;
      var singleSeparatePrice = payOnline ? Math.round(singleFullPrice * 0.9) : singleFullPrice;

      // 3. Update Pack button prices & states
      packBtns.forEach(function(btn) {
        var p = btn.getAttribute('data-package');
        var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
        var isActive = (p === selectedPackage);

        btn.classList.toggle('active', isActive);
        btn.style.borderColor = isActive ? 'var(--color-brass-bright)' : 'var(--color-line-strong)';
        btn.style.background = isActive ? 'var(--color-panel-2)' : 'var(--color-panel)';
        var title = btn.querySelector('.pack-title');
        if (title) title.style.color = isActive ? 'var(--color-brass-bright)' : 'var(--color-paper)';

        var v = findVariant(selectedSize, p);
        if (v) {
          var fullPrice = v.price / 100;
          var payable = payOnline ? Math.round(fullPrice * 0.9) : fullPrice;
          var perUnit = Math.round(payable / qty);
          var savedVsSeparate = Math.max(0, (singleSeparatePrice * qty) - payable);

          var priceEl = btn.querySelector('.pack-price');
          if (priceEl) priceEl.textContent = formatMoney(payable);

          var perUnitEl = btn.querySelector('.pack-per-unit');
          if (perUnitEl) perUnitEl.textContent = formatMoney(perUnit) + ' per pillow';

          var savingsEl = btn.querySelector('.pack-savings');
          if (savingsEl) {
            if (savedVsSeparate > 0) {
              savingsEl.style.display = 'block';
              savingsEl.textContent = 'Save ' + formatMoney(savedVsSeparate);
            } else {
              savingsEl.style.display = 'none';
            }
          }
        }
      });

      // 4. Update Current Selected Variant details
      var currentVariant = findVariant(selectedSize, selectedPackage);
      if (currentVariant) {
        if (variantIdInput) variantIdInput.value = currentVariant.id;

        var fullPrice = currentVariant.price / 100;
        var compareAt = currentVariant.compare_at_price ? (currentVariant.compare_at_price / 100) : (fullPrice * 1.5);
        var payable = payOnline ? Math.round(fullPrice * 0.9) : fullPrice;
        var prepaidPrice = Math.round(fullPrice * 0.9);
        var offPct = compareAt > payable ? Math.round(((compareAt - payable) / compareAt) * 100) : 0;

        if (mainPayableEl) mainPayableEl.textContent = formatMoney(payable);
        if (mainCompareEl) mainCompareEl.textContent = formatMoney(compareAt);
        if (mainOffPercentEl) mainOffPercentEl.textContent = offPct + '% off';
        if (buyNowBtn) buyNowBtn.textContent = 'Buy now · ' + formatMoney(payable);

        if (mainPriceTypeBadge) {
          mainPriceTypeBadge.textContent = payOnline
            ? 'Prepaid price · Save 10%'
            : 'Cash on Delivery price';
        }

        if (mainCodPriceNotice) {
          mainCodPriceNotice.textContent = payOnline
            ? formatMoney(fullPrice) + ' on Cash on Delivery'
            : formatMoney(prepaidPrice) + ' when paying online (Save 10%)';
        }

        var offBadges = container.querySelectorAll('.config-off-badge');
        offBadges.forEach(function(b) { b.textContent = offPct + '% off today'; });

        if (paymentSwitchPrice) {
          paymentSwitchPrice.textContent = payOnline
            ? formatMoney(prepaidPrice) + ' prepaid · ' + formatMoney(fullPrice) + ' COD'
            : formatMoney(fullPrice) + ' COD · ' + formatMoney(prepaidPrice) + ' prepaid';
        }

        if (configSummaryText) {
          configSummaryText.textContent = selectedSize + ' · ' + selectedPackage + ' · ' +
            (payOnline ? formatMoney(prepaidPrice) + ' prepaid with 10% online discount (or ' + formatMoney(fullPrice) + ' COD)' : formatMoney(fullPrice) + ' Cash on Delivery (pay courier upon arrival)') +
            '. Inclusive of all taxes. Dispatched within 24 hours.';
        }

        if (packBlurbEl) {
          packBlurbEl.textContent = PACK_BLURBS[selectedPackage] || '';
        }

        // Broadcast variant change event for sticky bars and media switchers
        var event = new CustomEvent('nidra:variant-changed', {
          detail: {
            variant: currentVariant,
            size: selectedSize,
            package: selectedPackage,
            payOnline: payOnline,
            payable: payable,
            fullPrice: fullPrice
          }
        });
        document.dispatchEvent(event);
      }
    }

    // Event Listeners for Size Selection
    sizeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var prevSize = selectedSize;
        selectedSize = btn.getAttribute('data-size');
        if (typeof window.clarity === 'function') {
          window.clarity('event', 'size_select_' + selectedSize.toLowerCase());
          window.clarity('set', 'selected_size', selectedSize);
          if (prevSize && prevSize !== selectedSize) {
            window.clarity('event', 'switch_' + prevSize.toLowerCase() + '_to_' + selectedSize.toLowerCase());
          }
        }
        updateUI();
      });
    });

    // Event Listeners for Pack Selection
    packBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectedPackage = btn.getAttribute('data-package');
        if (typeof window.clarity === 'function') {
          window.clarity('event', 'pack_select_' + selectedPackage.replace(/\s+/g, '_').toLowerCase());
        }
        updateUI();
      });
    });

    // Event Listener for Payment Switcher
    if (paymentSwitchBtn) {
      paymentSwitchBtn.addEventListener('click', function() {
        payOnline = !payOnline;
        var track = paymentSwitchBtn.querySelector('.switch-track');
        var thumb = paymentSwitchBtn.querySelector('.switch-thumb');
        if (track) {
          track.style.background = payOnline ? 'var(--color-brass-bright)' : 'var(--color-panel-2)';
          track.style.borderColor = payOnline ? 'var(--color-brass-bright)' : 'var(--color-line-strong)';
        }
        if (thumb) {
          thumb.style.transform = payOnline ? 'translateX(16px)' : 'translateX(2px)';
        }
        paymentSwitchBtn.setAttribute('aria-checked', payOnline ? 'true' : 'false');
        if (typeof window.clarity === 'function') {
          window.clarity('event', payOnline ? 'pdp_prepaid_selected' : 'pdp_cod_selected');
          window.clarity('set', 'pdp_payment_mode', payOnline ? 'prepaid' : 'cod');
        }
        updateUI();
      });
    }

    // Add To Cart Handler
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        var currentVariant = findVariant(selectedSize, selectedPackage);
        if (!currentVariant) return;

        if (typeof window.clarity === 'function') {
          window.clarity('event', 'add_to_cart_clicked');
          window.clarity('set', 'added_variant', currentVariant.title || selectedSize + ' / ' + selectedPackage);
        }

        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Adding…';

        if (window.NidraCart) {
          window.NidraCart.add({
            id: currentVariant.id,
            quantity: 1,
            payOnline: payOnline
          }).finally(function() {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = 'Add to cart';
          });
        }
      });
    }

    // Buy Now Handler -> Direct Checkout
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var currentVariant = findVariant(selectedSize, selectedPackage);
        if (!currentVariant) return;

        if (typeof window.clarity === 'function') {
          window.clarity('event', 'buy_now_clicked');
          window.clarity('set', 'buy_now_variant', currentVariant.title || selectedSize + ' / ' + selectedPackage);
          window.clarity('set', 'buy_now_payment_mode', payOnline ? 'prepaid' : 'cod');
        }

        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'One moment…';

        var prepaidCode = (window.ShopifyTheme && window.ShopifyTheme.settings && window.ShopifyTheme.settings.prepaid_code) ? window.ShopifyTheme.settings.prepaid_code : 'PREPAID10';
        var checkoutUrl = payOnline ? ('/checkout?discount=' + encodeURIComponent(prepaidCode)) : '/checkout';

        if (window.NidraCart) {
          window.NidraCart.add({
            id: currentVariant.id,
            quantity: 1,
            payOnline: payOnline,
            openDrawer: false
          }).then(function() {
            window.location.href = checkoutUrl;
          }).catch(function(err) {
            console.error('[Nidra] Buy now fallback to permalink', err);
            window.location.href = '/cart/' + currentVariant.id + ':1' + (payOnline ? ('?discount=' + encodeURIComponent(prepaidCode)) : '');
          });
        } else {
          // Direct fallback if NidraCart is unavailable
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: currentVariant.id, quantity: 1 })
          }).then(function() {
            window.location.href = checkoutUrl;
          }).catch(function() {
            window.location.href = '/cart/' + currentVariant.id + ':1' + (payOnline ? ('?discount=' + encodeURIComponent(prepaidCode)) : '');
          });
        }
      });
    }

    // Initial render
    updateUI();
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-configurator').forEach(initConfigurator);
  });
})();
